module.exports = __webpack_public_path__ + "static/media/Eye-Closed.090048be.svg";